import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import Feed from '../components/activity/Feed'
import HomeFeedEmpty from '../components/activity/HomeFeedEmpty'
import ClientOnlyLottie from '../components/common/ClientOnlyLottie'
import EmptyView from '../components/common/EmptyView'
import Loading from '../components/common/Loading'
import OnboardingModal from '../components/common/modal/OnboardingModal'
import MobileTopNav from '../components/common/nav/MobileTopNav'
import Layout from '../components/layouts/Layout'
import Meta from '../components/meta/Meta'
import QuestionnaireCTA from '../components/onboarding/questionnaire/QuestionnaireCTA'
import useUser from '../lib/useUser'
import { useTranslation } from '../lib/i18n'
import HomePageEmpty from '../public/lottie/HomePageEmpty.json'

export default function Home() {
  const router = useRouter()
  const { post } = router.query
  const [showPostModal, setShowPostModal] = useState(post === 'new')
  const { user, error } = useUser({ redirectTo: '/signup' })
  const { t } = useTranslation()

  useEffect(() => {
    setShowPostModal(post === 'new')
  }, [router, post])

  if (error) {
    return (
      <EmptyView
        instructions={t('home.empty.emptyInstructions')}
        title={t('home.welcomeMessage')}
        accessory={
          <ClientOnlyLottie
            loop
            animationData={HomePageEmpty}
            play
            style={{ width: 350, height: 350 }}
          />
        }
      />
    )
  }

  if (!user) {
    return <Loading />
  }

  return (
    <>
      <Meta title={t('home.metaTitle')} />
      <Layout>
        <OnboardingModal user={user} />
        <MobileTopNav title={t('navigation.home')} />
        <div className="sm:w-full md:w-3/4 max-w-7xl mx-auto pb-10">
          <QuestionnaireCTA />
          <Feed
            showButton
            detailedActivityButton
            modalVisible={showPostModal}
            EmptyOverrideComponent={HomeFeedEmpty}
          />
        </div>
      </Layout>
    </>
  )
}
